import fetchAPI from '../fetchAPI';

export const callCreateTeams = async (data: any): Promise<iResponse<Team>> => {
  const response: iResponse<Team> = await fetchAPI({
    method: `POST`,
    route: `team`,
    data
  });

  // const {error} = response;
  // if (error) throw new ResponseError(error);

  return response;
};

export default callCreateTeams;
